import { kebabCase } from 'lodash';
import { isNetworkSubAccount } from 'modules/account-management/accountType';
import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { normalizeColumnDefs } from 'modules/campaigns/modules/campaigns-reports/utils';
import { getLandingPageStatusType } from 'modules/landing-pages/consts/landingPageStatus';
import { updateLandingPage } from 'modules/landing-pages/flows/updateLandingPage';
import {
    gridUTCDateFormatter,
    LandingPagesActionsCellRenderer,
    LandingPageSlugCellRenderer,
    LandingPagesTaboolaPixelCellRenderer,
    StatusCellRenderer,
    ToggleSwitchCellRenderer,
    withCampaignEditIndication,
} from '../../../components';
import {
    actionsColumnType,
    defaultColumnDefinition,
    leftPinnedToggleColumn,
    lockedColumn,
    rightPinnedColumn,
    staticColumn,
} from '../../columns';
import { LANDING_PAGES_REPORT_ID } from './landingPagesReportId';

const columnDefinition = [
    {
        field: FIELDS.IS_ACTIVE.field,
        headerName: FIELDS.IS_ACTIVE.label,
        type: [leftPinnedToggleColumn, staticColumn, lockedColumn],
        cellRenderer: ToggleSwitchCellRenderer,
        valueChangeHandler: ({ isActive }, landingPage) =>
            updateLandingPage({
                landingPageId: landingPage?.id,
                accountName: landingPage?.accountName,
                isActive,
                ...(isActive ? { slug: kebabCase(landingPage.title) } : {}),
            }),
        // TODO: this is for optimistic UI. make sure you update all relevant values, including this specific cell
        // valueSetter: params => {
        //     console.log(params);
        //     params.data[FIELDS.IS_ACTIVE.field] = params.newValue;
        //     return true;
        // },
    },
    {
        field: FIELDS.ID.field,
        headerName: FIELDS.ID.label,
        type: [defaultColumnDefinition],
    },
    {
        field: FIELDS.TITLE.field,
        headerName: FIELDS.NAME.label,
        type: [defaultColumnDefinition],
        cellRenderer: FIELDS.NAME.cellRenderer,
    },
    {
        field: FIELDS.LANDING_PAGES_STATUS.field,
        headerName: FIELDS.LANDING_PAGES_STATUS.label,
        cellRenderer: StatusCellRenderer,
        cellRendererParams: {
            getStatusType: getLandingPageStatusType,
            disableValueTooltip: true,
            hidePhaseLabel: true,
            msgIdPrefix: 'landing.pages.report.status',
        },
        type: [defaultColumnDefinition],
    },
    {
        field: FIELDS.LANDING_PAGES_SLUG.field,
        headerName: FIELDS.LANDING_PAGES_SLUG.label,
        cellRenderer: LandingPageSlugCellRenderer,
        width: 300,
        type: [defaultColumnDefinition],
    },
    {
        field: FIELDS.LANDING_PAGES_TABOOLA_PIXEL.field,
        headerName: FIELDS.LANDING_PAGES_TABOOLA_PIXEL.label,
        cellRenderer: LandingPagesTaboolaPixelCellRenderer,
        visibilityCondition: ({ selectedAccount }) => isNetworkSubAccount(selectedAccount),
        type: [defaultColumnDefinition],
    },
    {
        ...FIELDS.LANDING_PAGES_CREATE_TIME,
        headerName: FIELDS.LANDING_PAGES_CREATE_TIME.label,
        valueFormatter: gridUTCDateFormatter,
        type: [defaultColumnDefinition],
    },
    {
        ...FIELDS.LANDING_PAGES_UPDATE_TIME,
        headerName: FIELDS.LANDING_PAGES_UPDATE_TIME.label,
        valueFormatter: gridUTCDateFormatter,
        type: [defaultColumnDefinition],
    },
    {
        ...FIELDS.LANDING_PAGES_PUBLISH_TIME,
        headerName: FIELDS.LANDING_PAGES_PUBLISH_TIME.label,
        valueFormatter: gridUTCDateFormatter,
        type: [defaultColumnDefinition],
    },
    {
        field: FIELDS.CREATED_BY.field,
        headerName: FIELDS.CREATED_BY.label,
        type: [defaultColumnDefinition],
    },
    {
        field: FIELDS.UPDATED_BY.field,
        headerName: FIELDS.UPDATED_BY.label,
        type: [defaultColumnDefinition],
    },
    {
        field: FIELDS.PUBLISHED_BY.field,
        headerName: FIELDS.PUBLISHED_BY.label,
        type: [defaultColumnDefinition],
    },
    {
        headerName: FIELDS.ACTIONS_COLUMN.label,
        field: FIELDS.ACTIONS_COLUMN.field,
        type: [rightPinnedColumn, actionsColumnType, staticColumn],
        cellRenderer: LandingPagesActionsCellRenderer,
        csv: false,
        minWidth: 100,
        maxWidth: 100,
        width: 100,
    },
];

export default normalizeColumnDefs(columnDefinition, LANDING_PAGES_REPORT_ID, withCampaignEditIndication);
